export var version = "3.13.6";
//# sourceMappingURL=version.js.map